import { useGlobalPreview } from '../hooks/useGlobalPreview';
import PreviewPanel from './PreviewPanel';
import type { PreviewState } from './PreviewPanel';

/**
 * Global preview panel that persists across CMS page navigation.
 * Renders in the Layout, not in individual editor pages.
 * The iframe stays alive so design/content changes are cumulative.
 */
export default function GlobalPreview() {
  const {
    isOpen,
    setIsOpen,
    subdomain,
    currentPage,
    previewState,
    previewError,
    cacheBust,
    triggerPreview,
    refreshIframe,
    iframeRef,
    replayQueue,
    previewDirty,
  } = useGlobalPreview();

  if (!isOpen) return null;

  return (
    <PreviewPanel
      subdomain={subdomain}
      currentPage={currentPage}
      state={previewState as PreviewState}
      errorMsg={previewError}
      cacheBust={cacheBust}
      onTriggerPreview={triggerPreview}
      onRefreshIframe={refreshIframe}
      collapsed={false}
      onToggleCollapsed={() => setIsOpen(false)}
      iframeRef={iframeRef}
      autoTrigger
      onIframeLoad={replayQueue}
      previewDirty={previewDirty}
    />
  );
}
